import React from 'react';
import { useCurrentUser, userSelectors } from '@marvelapp/ballpark-application';
import { Button, Link } from '@marvelapp/ballpark-components';
export function UpgradeButton() {
    const user = useCurrentUser();
    const isEnterpriseAndTrialExpired = userSelectors.isEnterpriseAndTrialExpired(user);
    const isLockedFreePlan = userSelectors.isLockedFreePlan(user);
    if (isEnterpriseAndTrialExpired || isLockedFreePlan) {
        return (React.createElement(Link, { display: "block", "data-testid": "upgrade-button", to: { pathname: '/plans', state: { modal: true } } },
            React.createElement(Button, { kind: "ghost" }, "Upgrade now")));
    }
    return null;
}
